<div class="bar-preview"><h3>{{ 'loginpreview.demoBar' | translate }}</h3><a routerLink="/basic">{{ 'loginpreview.backLink' | translate }}</a></div>
<div class="main">
    
    
    <div class="login-modal-content">
        <div class="modal-login">
            <div class="background-white">
                <form  [formGroup]="form" >

                    <h1>{{ 'loginpreview.title' | translate }}</h1>
                    <input   type="text" [placeholder]="'loginpreview.email.placeholder' | translate">
                    <small 
                    class="form-error-msg"> {{ 'loginpreview.email.required' | translate }} </small>

                    <input  type="password" [placeholder]="'loginpreview.password.placeholder' | translate">
                    <small class="form-error-msg"> {{ 'loginpreview.password.required' | translate }} </small>

                    <p>{{ 'loginpreview.forgotPassword' | translate }}</p>
                    <a >{{ 'loginpreview.forgotPasswordLink' | translate }}</a>
                    <div class="options">
                        <!-- <div class="checkbox">
                            <input type="checkbox" id="checkbox-remember" class="cookies">
                            <label for="checkbox-remember">Recuerdame<br>en este sitio</label>
                        </div> -->
                        <button>{{ 'loginpreview.loginButton' | translate }}</button>
                    </div>

                </form>
               
            </div>
            <div class="transparent-background">
                <p>{{ 'loginpreview.newAccount' | translate }}</p>
                <!--button (click)="onRegisterClick()">Regístrate</button-->
                <button>{{ 'loginpreview.registerButton' | translate }}</button>
            </div>
        </div>
    </div>
    <img src="../../assets/images/grafica2.png" alt="graff">
</div>